/**
 * Shared cross-page constants
 * 跨页面共享常量
 */

/**
 * Sentinel table number meaning "entered without a table number" (e.g. venue sub-group / vgs mode).
 * Not a real table number — any table-related check must ignore it.
 */
/**
 * "无桌号入口"的桌号占位符（如 venue sub-group / vgs 模式）。
 * 不是真实桌号——所有桌号相关的判断都必须忽略它。
 */
export const NO_INPUT_TABLE_NUMBER = 'n-t'
